import { render, staticRenderFns } from "./ViewPropertyBills.vue?vue&type=template&id=37d8a6b6"
import script from "./ViewPropertyBills.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPropertyBills.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports